var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGtin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E3FBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8861 14.6022L14.3463 14.7977C14.2334 15.0634 14.1682 15.378 14.1345 15.8492C14.1003 16.326 14.1 16.9271 14.1 17.7634V22.2365C14.1 23.0729 14.1003 23.674 14.1345 24.1508C14.1682 24.6219 14.2334 24.9365 14.3463 25.2022L14.3463 25.2023C14.5516 25.6857 14.8739 26.0963 15.275 26.3932C15.492 26.5539 15.7613 26.6754 16.1829 26.7934C16.6117 26.9135 17.1611 27.0206 17.9326 27.1705C17.9326 27.1705 17.9326 27.1705 17.9326 27.1705L17.8373 27.6613L17.8382 27.6615C19.4256 27.9699 20.2195 28.1241 20.8373 27.8783C21.3507 27.6741 21.7831 27.2884 22.0631 26.7853L13.8861 14.6022ZM13.8861 14.6022L14.3463 14.7977C14.5516 14.3143 14.8739 13.9037 15.275 13.6067C15.492 13.446 15.7613 13.3246 16.1829 13.2065C16.6117 13.0864 17.1611 12.9793 17.9326 12.8294L17.8374 12.3391L17.9326 12.8294C18.7362 12.6733 19.3046 12.5634 19.7498 12.5199C20.1895 12.4769 20.4504 12.5059 20.6525 12.5862L20.6525 12.5863C21.054 12.746 21.3997 13.0507 21.6261 13.4578C21.7442 13.6701 21.8199 13.955 21.8596 14.4327C21.8995 14.914 21.8999 15.5364 21.8999 16.4072V23.5927C21.8999 24.4636 21.8995 25.0859 21.8596 25.5672C21.8199 26.045 21.7442 26.3298 21.6261 26.5422L13.8861 14.6022Z",
    stroke: "#62856F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 17.7634C13.6 16.1049 13.6 15.2757 13.8861 14.6022C14.125 14.0396 14.5022 13.5567 14.9775 13.2049C15.5465 12.7836 16.3101 12.6353 17.8373 12.3386C19.4253 12.0301 20.2194 11.8758 20.8373 12.1217C21.3507 12.3259 21.7831 12.7116 22.0631 13.2147C22.3999 13.8203 22.3999 14.6826 22.3999 16.4072V23.5927C22.3999 25.3173 22.3999 26.1797 22.0631 26.7853C21.7831 27.2884 21.3507 27.6741 20.8373 27.8783C20.2194 28.1241 19.4253 27.9698 17.8373 27.6613C16.3101 27.3646 15.5465 27.2163 14.9775 26.7951C14.5022 26.4433 14.125 25.9604 13.8861 25.3977C13.6 24.7243 13.6 23.895 13.6 22.2365V17.7634Z",
    stroke: "#62856F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 26.2385C23.5579 26.3589 25.1199 26.7292 25.95 25.6707C26.4 25.0969 26.4 24.2228 26.4 22.4746V17.5253C26.4 15.7771 26.4 14.903 25.95 14.3292C25.1199 13.2707 23.5579 13.641 22.4 13.7614",
    stroke: "#62856F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.7999V19.2",
    stroke: "#62856F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 26.1813H28",
    stroke: "#62856F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.4H14.4",
    stroke: "#62856F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtin);
export default __webpack_public_path__ + "static/media/gtin.868dff312963ada12f0ed889162017e5.svg";
export { ForwardRef as ReactComponent };